import { object } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { PerecentBoxOutlineIcon } from '../../../../atoms/material-icons';
import { fetchStockId } from '../../utils/marketsUtils';
import EmptyState from '../empty-state';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { useInterval } from '../../../../../helpers/custom-hooks';
import { isWithinTradingHours } from '../../../../../helpers/utils';
import './total-returns.m.css';

const TotalReturns = () => {
  const [TotalReturns, setTotalReturns] = useState({});
  const [initialLoading, setInitialLoading] = useState(true);
  const tradingHolidays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'trading_holidays'], []),
  );
  const specialTradingDays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'special_trading_days'], {}),
  );

  const getTotalReturnsData = async () => {
    const stockId = fetchStockId();
    const stockDetailsResponse = await fetch(`/next/feapi/stock/stock-details/${stockId}`);
    const stockDetailsData = await stockDetailsResponse.json();
    const stockArray = await stockDetailsData?.filter(
      (stock) => stock?.STOCKID?.toString() === fetchStockId(),
    );

    const response = await fetch(`/next/feapi/stock/total-returns/${stockArray[0]?.STOCKID}`);
    const data = await response.json();
    setTotalReturns(data?.data);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
      getTotalReturnsData();
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useInterval(() => {
    if (isWithinTradingHours(tradingHolidays, specialTradingDays)) {
      getTotalReturnsData();
    }
  }, 30000);

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="total-returns-container">
      <div styleName="header-title-container">
        <PerecentBoxOutlineIcon size={'26px'} color={'#d01e51'} />
        <h2 styleName="list-header-title">Total Returns</h2>
      </div>
      {TotalReturns && Object.keys(TotalReturns).length !== 0 ? (
        <div styleName="total-returns-body">
          <div styleName="total-returns-heading">
            <div styleName="gold-img-container">
              <img
                src="https://media.assettype.com/bloombergquint/2022-10/40cbe051-7cec-4e11-b2bd-58aa32696af7/gold_coin_returns2x.png"
                alt="gold-coin"
                width="85px"
                height="85px"
              />
            </div>
            <div>
              <h4 styleName="yield-perc">
                {TotalReturns?.yieldPercentage ? `${TotalReturns?.yieldPercentage} %` : '-'}
              </h4>
              <span styleName="yield-desc">Dividend Yield</span>
            </div>
          </div>
          <div styleName="total-returns-msg">
            <div>
              <span className="icon-ic_lightbulb" />
              <span>INSIGHTS</span>
            </div>
            <span>{TotalReturns?.headerMsg}</span>
          </div>
          <div styleName="total-returns-body">
            <table>
              <tr>
                <th>TIME</th>
                <th>RETURN</th>
                <th>DIVIDEND</th>
                <th>TOTAL</th>
              </tr>
              {TotalReturns?.tableDetails?.map((detail, index) => {
                return (
                  <tr key={index}>
                    <td>
                      {detail?.period ? `${detail?.period}` : <span styleName="null-value">-</span>}
                    </td>
                    <td styleName={detail?.priceReturn < 0 ? 'negative-value' : 'positive-value'}>
                      {detail?.priceReturn ? (
                        `${detail?.priceReturn}%`
                      ) : (
                        <span styleName="null-value">-</span>
                      )}
                    </td>
                    <td
                      styleName={detail?.dividendReturn < 0 ? 'negative-value' : 'positive-value'}
                    >
                      {detail?.dividendReturn ? (
                        `${detail?.dividendReturn} %`
                      ) : (
                        <span styleName="null-value">-</span>
                      )}
                    </td>
                    <td styleName={detail?.totalReturn < 0 ? 'negative-value' : 'positive-value'}>
                      {detail?.totalReturn ? (
                        `${detail?.totalReturn}%`
                      ) : (
                        <span styleName="null-value">-</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
        </div>
      ) : (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState subTextMessage={'for this stock at the moment'} />
          </div>
        </div>
      )}
    </div>
  );
};

TotalReturns.propTypes = {
  currentStock: object,
};

export default TotalReturns;
